import { Injectable } from "@angular/core";
import moment from "moment";
import { ApplicationService } from "../../../../services/application.service";
import { AuthService } from "../../../../services/auth.service";
import { MyUtils } from "../../../../services/my-utils.service";
import { RecoveryPlanStatus } from "../../hot-alert/configurations/recovery-plan-status";
import { Adapter } from "../../../records/classes/adapter";
import { ActionPlan } from "./action-plan";

@Injectable({ providedIn: "root" })
export class ActionPlanAdapter extends Adapter<ActionPlan, any> {
  constructor(
    private authService: AuthService,
    private applicationService: ApplicationService,
    private utils: MyUtils
  ) {
    super();
  }
  toView(plan: ActionPlan) {
    return new ActionPlan(plan);
  }

  generateDeleteBody(plan: ActionPlan) {
    let ac = {
      actionPlanId: plan.actionPlanId,
      status: RecoveryPlanStatus.DELETE,
      usrCancel: this.authService.email,
      note: null,
      title: null,
      description: null,
      sectionValue: plan.sectionValue,
      kpi: null,
      kpiGoalValue: null,
      dtStart: null,
      dtEnd: null,
      brandId: null,
      regionId: null,
      marketId: null,
      listOutlets: null,
      usrInsert: null,
      wave: null,
    };
    return ac;
  }

  generateCloseBody(plan: ActionPlan, formValue: { comment: string }) {
    let ac = {
      actionPlanId: plan.actionPlanId,
      status: RecoveryPlanStatus.CLOSE,
      usrClose: this.authService.email,
      note: formValue.comment,
      title: null,
      description: null,
      sectionValue: plan.sectionValue,
      kpi: null,
      kpiGoalValue: null,
      dtStart: null,
      dtEnd: null,
      brandId: null,
      regionId: null,
      marketId: null,
      listOutlets: null,
      usrInsert: null,
      wave: null,
    };
    return ac;
  }

  generateCreateBody(formData: any) {
    const listOutlets = formData.outlets[0].split("#");
    const [dealer, bo, subregion] = listOutlets;
    let sectionValue = (
      this.applicationService.navBarSelectValue.idItem as string
    ).toLowerCase();
   
    sectionValue = sectionValue[0].toUpperCase() + sectionValue.substring(1);
    let ac = {
      title: formData.title,
      description: formData.description,
      sectionValue: sectionValue,
      status: RecoveryPlanStatus.OPEN,
      kpi: formData.kpi,
      kpiGoalValue: formData.kpiGoalValue,
      dtStart: this.parseDate(formData.dateStart),
      dtEnd: this.parseDate(formData.dateEnd),
      note: formData.note || "",
      brandId: this.utils.settingsPayloadValue.payload.network.brand[0],
      regionId:
        this.utils.settingsPayloadValue.payload.network.regions[0].region,
      marketId:
        this.utils.settingsPayloadValue.payload.network.regions[0].subRegions[0]
          .market[0],
      listOutlets: formData.outlets,
      usrInsert: this.authService.email,
      subRegion: subregion,
    };
    return ac;
  }

  private parseDate(date: moment.Moment | Date) {
    if (!moment.isMoment(date)) {
      date = moment(date);
    }
    let stringDate = date.toISOString();
    return stringDate;
  }
}
